module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Bold.2a16d467.otf";